const useIsMobile = () => {
  return window.innerWidth <= 768;
};

export default useIsMobile;
